<template>
  <BasePageContainer
    class="pt-10">
    <PageHeader
      has-back
      with-members>
      緊急連絡先
    </PageHeader>
    <label class="border border-dark fs-m font-weight-bold px-1">
      緊急連絡先
    </label>
    <EmergencyContactsForm
      v-if="initialized"
      ref="form"
      :emergency-contacts="emergencyContacts"
      @submit="postEmergencyContacts" />
  </BasePageContainer>
</template>

<script>
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import EmergencyContactsForm from '@/components/view/profile/emergency_contacts/EmergencyContactsForm.vue'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    EmergencyContactsForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      emergencyContacts: [],
      initialized: false
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  created() {
    this.fetchEmergencyContacts().then(res => {
      this.emergencyContacts = res.data.results
    }).finally(() => {
      this.initialized = true
    })
  },
  methods: {
    fetchEmergencyContacts() {
      return this.$axios.get('/profiles/emergency-contacts/', {
        params: {
          user_id: this.userId
        }
      })
    },
    postEmergencyContacts(data) {
      return this.$axios.post('/profiles/emergency-contacts/', data)
        .then(() => {
          this.$store.commit('notify/set', {
            message: '緊急連絡先を更新しました',
            type: 'success'
          })
          this.canLeave = true
          this.$nextTick(() => {
            this.$router.push(`/members/${this.userId}/profile`, {
              replace: true
            })
          })
        }).catch(err => {
          console.error(err)
          this.$store.commit('notify/set', {
            message: '緊急連絡先の更新に失敗しました',
            type: 'error'
          })
        })
    },
  }
}
</script>

<style>

</style>